module.exports = __webpack_public_path__ + "img/4c4782a.png";